module.exports = __webpack_public_path__ + "static/media/ipadpro3_splash.4a2080fb.png";